module.exports = __webpack_public_path__ + "img/allottee1_7-8-2021.2fb229e8.jpg";